/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type GetBuildingIntelligenceTimelineEventKindsItem =
    (typeof GetBuildingIntelligenceTimelineEventKindsItem)[keyof typeof GetBuildingIntelligenceTimelineEventKindsItem];

export const GetBuildingIntelligenceTimelineEventKindsItem = {
    issueDate: 'IssueDate',
    expiryDate: 'ExpiryDate',
} as const;
